module.exports = __webpack_public_path__ + "assets/img/subsidy-hero.084232fe.jpg";